import React from "react";
import { Link, Branding ,DisabledPrompt,BrandingStyle} from "bcms-react";
import { TableBody, TableColumnContainer, TableColumnView, TableItemContainer, TableItemTextView, TableView, WidgetContainer, WidgetView } from "components/shared";
import { CODAccount, CheckingAccount, LoanAccount, SavingsAccount } from "model";
import AccountSummaryBrandableLinksWidget from "../AccountSummaryBrandableLinksWidget";
import { SVGAsset } from "res";
import Util from "classes/Util";
import "./styles.css";
/**
 * @function AccountSummarySortableTableWidget
 * @return {React.Component}
 * @exported true
 * @description This is the main widget of the AccountSummarySortableTableWidget
 */
export default function AccountSummarySortableTableWidget(props) {
    const checkingAccts = CheckingAccount.initAll().map(account => <AccountSummarySortableView key={ "account_" + account.id }account ={account} />, []);
    const savingsAccts = SavingsAccount.initAll().map(account => <AccountSummarySortableView key={ "account_" + account.id } account ={account}/>, []);
    const codAccounts = CODAccount.initAll().map(account => <AccountSummarySortableView key={ "account_" + account.id }  account ={account}/>, []);
    const loanAccts = LoanAccount.initAll().map(account => <AccountSummarySortableView key={ "account_" + account.id }account ={account} />, []);
    
    return (
        <WidgetContainer className={"account-summary-sortable-table-widget " + props.className??""} >
            <WidgetView text="Account Summary">
            <AccountSummaryBrandableLinksWidget/>

                <AccountSummarySortableTable>

                    <AccountSummarySortableHeader dataPoint="Checking_Accounts" text="Checking Accounts" />
                    <AccountSummarySortableColumnHeader account={CheckingAccount.initAll()[0]}/>
                    {checkingAccts}
                    { !Util.inMabi && 
                    <Branding id="acctsumwidget_order_checks_abi22" value="true" default="false">
                        <>
                        <DisabledPrompt>
                            <Link>
                            <span data-point="Order_Checks" className="order-checks-link">Order Checks</span>
                            </Link>
                        </DisabledPrompt>
                        </>
                    </Branding>
                    }
                    
                    <AccountSummarySortableHeader text="Saving Accounts" />
                    <AccountSummarySortableColumnHeader account={SavingsAccount.initAll()[0]}/>
                    {savingsAccts}

                    <AccountSummarySortableHeader text="Certificate of Deposit" />
                    <AccountSummarySortableColumnHeader account={CODAccount.initAll()[0]}/>
                    {codAccounts}

                    <AccountSummarySortableHeader dataPoint="Loans" text="Loans" />
                    <AccountSummarySortableColumnHeader account={LoanAccount.initAll()[0]}/>
                    {loanAccts}

                </AccountSummarySortableTable>
            </WidgetView>
        </WidgetContainer>
    )
}

/**
 * @function AccountSummarySortableHeader
 * @return {React.Component}
 * @exported true
 * @description This components is the table body for the AccountSummarySortableTableWidget.
 */
export function AccountSummarySortableTable(props) {
    return (
        <TableView className="account-summary-sortable-table">
            {props.children}
        </TableView>
    );
}

/**
 * @function AccountSummarySortableHeader
 * @return {React.Component}
 * @exported true
 * @description This components shows the account type header.
 */
export function AccountSummarySortableHeader(props) {
    const text = props.text ?? "";
    const dataPoint = props.dataPoint ? { "dataPoint" : props.dataPoint } : {};

    return (
        <TableColumnContainer className="account-summary-sortable-header" >
            <TableColumnView className="text-left" { ...dataPoint } text={text} />
            <TableColumnView />
            <TableColumnView />
            <TableColumnView />
        </TableColumnContainer>
    );
}

/**
 * @function AccountSummarySortableColumnHeader
 * @return {React.Component}
 * @exported true
 * @description This components shows the table sortable column headers
 */
export function AccountSummarySortableColumnHeader(props) {
    const account = props.account;
    const availableBalance = account.availableBalance ? account.availableBalance.format() : false;
    const currentBalance = account.currentBalance ? account.currentBalance.format() : false;
    return (
        <TableColumnContainer className="account-summary-sortable-column-header">
            <TableColumnView className="text-left nickname" text="Account Nickname" icon="SortIcon" />
            {availableBalance ? false : <TableColumnView text="" />}
            {currentBalance ? false : <TableColumnView text="" />}
            <TableColumnView className="text-right account-number" text="Account Number" icon="SortIcon" />
            {availableBalance ? <TableColumnView className="text-right available-balance" text="Available Balance" icon="SortIcon" /> : false}
            {currentBalance ? <TableColumnView className="text-right current-balance" text="Current Balance" icon="SortIcon" /> : false}
        </TableColumnContainer>
    )
}

/**
 * @function AccountSummarySortableView
 * @param {STRING} nickname - Sets the account nickname
 * @param {STRING} accountNumber - Sets the four digit account number.
 * @param {STRING} availableBalance - Sets the available balance for the account.
 * @param {STRING} currentBalance - Sets the current balance for the account.
 * @return {React.Component}
 * @exported true
 * @description This component shows each account and account details.
 */
export function AccountSummarySortableView(props) {
    const account = props.account ?? {};
    const accountID = account.id ?? "";
    const nickname = account.nickname ?? "[Nickname]";
    const accountNumber = account.number ?? "[Account Number]";
    const availableBalance = account.availableBalance ? account.availableBalance.format() : false;
    const currentBalance = account.currentBalance ? account.currentBalance.format() : false;
    const accountNicknameLink = <Link to={"/accountdetails/" + account.id} dataPoint={ `Account_Name_${ accountID }` }>{account.nickname}</Link>;

    return (
        <TableBody>
            <TableItemContainer className="account-summary-sortable-view clickable">
                <TableItemTextView className="text-left nickname" text={ accountNicknameLink } />
                {availableBalance ? false : <TableItemTextView text="" />}
                {currentBalance ? false : <TableItemTextView text="" />}
                <TableItemTextView className="text-right account-number" data-point={ `Account_Number_${ accountID }` } text={accountNumber} />
                {availableBalance ? <TableItemTextView className="text-right available-balance" data-point={ `Account_Balance_${ accountID }` } text={availableBalance} /> : false}
                {currentBalance ? <TableItemTextView className="text-right current-balance" data-point={ `Account_Current_Balance_${ accountID }` } text={currentBalance} /> : false}
            </TableItemContainer>
        </TableBody>
    );
}   
